import React from 'react';
import { Outlet } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import StepNavigation from '../ui/StepNavigation';
import './UserLayout.css';

function UserLayout() {
  return (
    <div className="user-layout">
      {/* Step Navigation */}
      <StepNavigation />

      {/* Main Content */}
      <main className="user-main">
        <div className="main-container">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="user-footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>Need Help?</h4>
              <div className="contact-item">
                <Phone size={16} />
                <span>+92 300 1234567</span>
              </div>
              <div className="contact-item">
                <Mail size={16} />
                <span>support@anbpay.com</span>
              </div>
            </div>
            <div className="footer-section">
              <p className="footer-note">
                Your payment information is encrypted and secure. We never store your bank credentials.
              </p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 AnbPay. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default UserLayout;
